import ConfigDiffViewer from './ConfigDiffViewer';
import DiffView from './DiffView';

/** HITL 确认环节的变更 diff 载荷（与 backend hitl_diff_service.build_diff_payload 对齐） */
export interface HitlDiffPayload {
  type?: string;
  label?: string;
  before?: unknown;
  after?: unknown;
  diff?: string;
}

interface HitlDiffPreviewProps {
  /** diff 载荷：优先渲染行级 unified diff 文本，缺省时回退 before/after 快照对比 */
  diff: HitlDiffPayload;
}

const isRenderable = (value: unknown): value is object | string =>
  typeof value === 'string' || (typeof value === 'object' && value !== null);

/**
 * HITL「确认什么」变更预览（P4）：
 * - 有 unified diff 文本 → DiffView 行级着色渲染；
 * - 无 diff 文本但有 before/after 快照 → ConfigDiffViewer 快照对比；
 * - 快照一致（diff 为空串）→ 提示无行级差异。
 */
export default function HitlDiffPreview({ diff }: HitlDiffPreviewProps) {
  return (
    <div className="hitl-diff-preview">
      {diff.label && (
        <code className="text-muted text-xs" style={{ display: 'block', marginBottom: 4 }}>
          {diff.label}
        </code>
      )}
      {diff.diff ? (
        <DiffView diff={diff.diff} />
      ) : isRenderable(diff.before) && isRenderable(diff.after) ? (
        diff.diff === '' ? (
          <div className="text-muted text-sm">快照一致，无行级差异。</div>
        ) : (
          <ConfigDiffViewer left={diff.before} right={diff.after} />
        )
      ) : (
        <div className="text-muted text-sm">该确认环节未携带变更内容。</div>
      )}
    </div>
  );
}
